export default function Vector({color}) {
  return (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.25 9.43844L5.95 9.43844L11.725 3.59998C12.425 2.89228 12.425 1.83075 11.725 1.12305C11.025 0.415362 9.975 0.415362 9.275 1.12305L0.525 9.96921C-0.175 10.6769 -0.175 11.7384 0.525 12.4461L9.275 21.2923C9.975 22 11.025 22 11.725 21.2923C12.425 20.5846 12.425 19.5231 11.725 18.8154L5.95 12.9769L19.25 12.9769C20.3 12.9769 21 12.2692 21 11.2077C21 10.3231 20.3 9.43844 19.25 9.43844Z"
        fill={color?color: "#4C8395"}
      />
    </svg>
  );
}
